function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M287.261,260.35L256,246.803c0,0,7.314-24.278,7.704-25.938c0.285-1.214,0.437-2.48,0.437-3.781  c0-4.606-1.867-8.775-4.885-11.793l7.863-7.863c-5.03-5.031-11.979-8.141-19.655-8.141s-14.625,3.111-19.655,8.141l7.863,7.863  c-3.019,3.017-4.885,7.187-4.885,11.793c0,1.684,0.255,3.307,0.719,4.841l-11.837,11.837h21.513c0,0-8.894,13.36-13.749,24.33  c-4.855,10.971,0.067,24.363,11.288,29.351l6.488,2.884l10.793,10.145v11.118l-11.118,11.118h22.237v-22.236l10.145-10.145h20.985  c0.101-0.208,0.207-0.413,0.303-0.626C303.539,278.477,298.485,265.337,287.261,260.35z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function Svg009Uganda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("rect", {
    y: 85.326,
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 85.337
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.663,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 85.337
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.337,
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 85.337
  }), /*#__PURE__*/React.createElement("rect", {
    y: 426.663,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 85.337
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M341.334,255.998c0,47.132-38.202,85.334-85.334,85.334s-85.335-38.202-85.335-85.334  s38.202-85.334,85.335-85.334S341.334,208.866,341.334,255.998z"
  }), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg009Uganda);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };